export const textileRecycling = {
  heading: "Textile Recycling Services",
  intro:
    "This service specialises in secure uniform and textile disposal, providing you with a fully tailored collection, destruction and recycling service throughout the UK.",
  seoTitle: "Textile Recycling Services for Business UK | Preserve Earth",
  description:
    "Secure textile recycling for UK businesses: uniform and workwear collection, secure destruction and recycling. Request a quote today.",
  url: "https://preserveearth.co.uk/services/textile-recycling",
  image: "https://preserveearth.co.uk/images/optimised/textile-collection-bags-1200x675.webp",
  features: [
    {
      title: "Completely Secure Solution",
      body: "The textile recycling solution is safe and secure from every point of view.",
    },
    {
      title: "GDPR Compliance As Standard",
      body: "Support your business or organisation's GDPR compliance as standard.",
    },
    {
      title: "Recycled, Not Wasted",
      body: "The textile recycling service is committed to repurposing and recycling materials.",
    },
    {
      title: "Documented Collections",
      body: "Every collection is logged, and you receive an electronic note of secure destruction for your records.",
    },
  ],
  howItWorks:
    "This service offers the secure disposal of uniforms and textiles through two flexible options. For ongoing needs, we provide bin units delivered to your site, where items can be securely stored and collected on a scheduled basis by our team. For occasional or one-off requirements, we also offer ad hoc collections, where no bin units are required, we simply collect the materials directly from your premises. In both cases, all items are securely destroyed to protect your brand. You will receive an electronic note of secure destruction and can also request an Environmental Impact Statement upon completion.",
  steps: [
    "Secure Collection",
    "Sealed and Logged",
    "Secure Travel",
    "Textile Shredding",
    "Electronic Note of Secure Destruction",
    "Re-purpose & Remanufacture",
  ],
  shredding: [
    "We deliver tailored solutions to safeguard your brand and support your sustainability goals.",
    "How confident can your business be that expired or damaged branded garments are being disposed of securely and responsibly?",
    "Our uniform and textile shredding service offers a clear advantage ensuring brand protection through the secure collection, destruction, and recycling of both branded and non-branded garments. This process not only protects your reputation but also demonstrates a commitment to environmental responsibility, providing total peace of mind for business owners and stakeholders alike.",
  ],
  recycling:
    "This service offers specialised textile recycling tailored for end-of-life textiles including uniforms, PPE and other fabric materials. The primary and preferred route is a remanufacturing process to securely shred textiles and use the broken-down fibres to create the same type of product as the original textile, fibres can also be recycled into various products such as insulation, soundboards and geo-textiles. This service prioritises repurposing and recycling materials, contributing to environmental sustainability.",
  adHoc: [
    "Need a one-off textile collection?",
    "At Preserve Earth, we provide ad-hoc textile recycling collections for businesses that need a simple, reliable way to clear unwanted textiles, without committing to a regular service.",
    "Our ad-hoc collections operate on a 10-day service window (SLA). This allows us to plan efficient routes and coordinate collections when we're next operating in your area, helping us keep the service streamlined and cost-effective.",
  ],
  collectionOptions:
    "We offer simple, flexible textile collections to suit your setup, from a few bags to full pallets. If you already have standard bin bags or black bags filled with textiles, we can collect them directly from your site. Prefer something neater? We can send recycling sacks for you to fill, then collect within our 10-day service window when we're next in your area. For larger volumes, we also offer pallet collections, ideal for boxed or bulk materials. Please ensure pallets are tidy, secure, and no higher than 1.2 m. Pricing is per bag, sack, or pallet, so well-packed textiles help reduce cost. When you enquire, including photos of your textiles can help provide a quick, accurate quote. Whether it's a few bags or a full pallet, our team will confirm costs and collection details quickly.",
  console:
    "The system for textile destruction helps businesses correctly manage their brand and reduce any risk of misuse when it comes to uniform and branded workwear. The three-tier approach covers convenience, control and compliance, ensuring you and your business are protected against identity theft and fines. With an established reputation of security, integrity and sustainability, organisations that choose to partner with Preserve Earth can be assured that these core values are at the heart of everything we do.",
  collections: [
    "Unbranded Clothing Recycling",
    "Branded Uniform Recycling",
    "Secure Misprinted Textile Destruction",
    "Scheduled Clothing Collections",
    "One-off Textile Collections",
  ],
  coverage: "The service operates across the UK. We also serve clients in France and Belgium, who courier their items securely to our depot in France. Collections are offered in the UK only.",
  faqs: [
    {
      question: "How quickly can you collect textiles for recycling?",
      answer:
        "Our ad-hoc collections operate on a 10-day service window (SLA), so we can collect when we're next operating in your area.",
    },
    {
      question: "How are textile recycling collections priced?",
      answer: "Pricing is per bag, sack, or pallet, so well-packed textiles help reduce cost.",
    },
    {
      question: "Are there any requirements for pallet collections?",
      answer: "Please ensure pallets are tidy, secure, and no higher than 1.2 m.",
    },
    {
      question: "Will I receive proof that my textiles were destroyed?",
      answer:
        "Yes. You will receive an electronic note of secure destruction and can also request an Environmental Impact Statement upon completion.",
    },
    {
      question: "What happens to textiles after collection?",
      answer:
        "This service prioritises repurposing and recycling materials. The preferred route is remanufacturing, and fibres can also be recycled into products such as insulation, soundboards and geo-textiles.",
    },
    {
      question: "Can you dispose of PPE as well as uniforms?",
      answer:
        "Yes. The service covers end-of-life textiles including uniforms, PPE and other fabric materials, securely destroyed to protect your brand and then recycled.",
    },
    {
      question: "Is a one-off collection priced differently from a regular service?",
      answer:
        "Yes. A one-off collection is quoted for the bags, sacks or pallets you have ready, with no regular service needed. A regular service is quoted on the bin units on your site and how often we collect them.",
    },
    {
      question: "Does volume affect the price?",
      answer:
        "Yes. Volume and how well items are packed are the main factors, so photos and an estimate of the number of bags, sacks or pallets help us give an accurate quote.",
    },
    {
      question: "Which container size do we need?",
      answer:
        "For small amounts, standard bags or our recycling sacks work well. For ongoing needs we provide bin units on your site, and for larger volumes we collect pallets. We recommend the right option when we quote.",
    },
    {
      question: "How often will you collect?",
      answer:
        "Regular services are collected on a scheduled basis agreed with you. Ad-hoc collections operate on our 10-day service window.",
    },
    {
      question: "Is there a minimum contract term?",
      answer:
        "Ad-hoc and one-off collections need no regular commitment. For a scheduled service, the agreement length is set out in your tailored quote, so you know the term before you sign.",
    },
  ],
  sectors: {
    heading: "Who Is Our Uniform and PPE Disposal For?",
    intro:
      "Any organisation whose branded clothing could be misused if it left the business intact. It is well suited to:",
    items: [
      "Healthcare: scrubs, tunics, branded staff uniforms and PPE.",
      "Security: branded uniforms, hi-vis and workwear that could be used to impersonate your staff.",
      "Logistics: hi-vis, branded workwear and PPE from distribution sites and delivery teams.",
      "Hospitality: branded uniforms, aprons and chef whites.",
    ],
  },
  articles: [
    {
      title: "Why Shred Retired Corporate Uniforms? A Guide to Secure, Sustainable Disposal",
      slug: "corporate-uniform-recycling-a-sustainable-solution-for-business-waste",
    },
    { title: "Eco-Friendly PPE Disposal for Businesses", slug: "eco-friendly-ppe-disposal-for-businesses" },
    {
      title: "EPR in Textiles: Impact on Manufacturing Industry Today",
      slug: "epr-in-textiles-manufacturing-impact-today",
    },
  ],
};
